import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom"; // Import withRouter

function StudentHeader(props) {
  let { history } = props;

  const [drop, setDrop] = useState(true);

  // const gotoPage2 = (field) => {
  //   history.push(`/assessment/` + field);
  // };

  const gotoPage2 = (field) => {
    // const { history } = this.props;
    history.push(`/assessment/${field}`);
  };


  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  function matchPathFn(name) {
    let pathname = window.location.hash;
    return pathname === `#/assessment/${name}`;
  }

  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [colorMode] = useState(false);
  useEffect(() => {
    document.body.classList.toggle("dark", colorMode);
  }, [colorMode]);

  return (
    <header
      className={`flex items-center z-20 top-0 w-full h-20 border-b border-[#E8E8E8] ease-in-out duration-150 ${scrollPosition > 50 ? "bg-white fixed shadow-sm " : "sticky bg-transparent"
        }`}
    >
      <nav className="flex items-center justify-between w-full px-4 mx-auto xl:w-11/12 xl:px-0 ">
        <div className="flex flex-row items-center gap-4">
          <div className="lg:hidden">
            <button onClick={toggleMobileMenu} className="lg:hidden block p-2 text-[#3D405B] bg-[#212121]/5 rounded-full">
              <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-menu-2" width="28" height="28" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">  {" "}  <path stroke="none" d="M0 0h24v24H0z" fill="none" />{" "}  <line x1="4" y1="6" x2="20" y2="6" />{" "}  <line x1="4" y1="12" x2="20" y2="12" />{" "}  <line x1="4" y1="18" x2="20" y2="18" /></svg>
            </button>
          </div>
          <img onClick={() => gotoPage2("home")} src="/img/TalentPlusStrengths_logo.svg" alt="TalentPlusStrengths_logo" className="bg-cover cursor-pointer md:w-36 w-28 mr-4" />

          <div className={`${isMobileMenuOpen ? "block" : "hidden"} lg:flex lg:items-center gap-8 `}>
            <div className="absolute left-0 z-40 flex flex-col items-start w-full gap-8 py-0 p-6 pb-6 bg-white border-b shadow-md lg:items-center lg:flex-row lg:relative lg:top-auto lg:p-0 top-0 lg:bg-transparent lg:w-auto lg:border-none lg:shadow-none md:h-auto md:overflow-visible h-screen overflow-y-auto ">
              <div className="lg:hidden flex justify-between w-full items-center sticky top-0 h-20 bg-white py-2  ">
                <h1 className="text-xl font-medium text-[#212121]">Menu</h1>
                <button onClick={toggleMobileMenu} className="p-2 rounded-full bg-slate-100">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-x">  <path stroke="none" d="M0 0h24v24H0z" fill="none" />  <path d="M18 6l-12 12" />  <path d="M6 6l12 12" /></svg>
                </button>
              </div>

              <a onClick={() => gotoPage2("student-dashboard")} className={matchPathFn("student-dashboard") ? "flex justify-between items-center text-base cursor-pointer text-[#2196f3] border-b-2 border-[#2196f3] lg:w-auto w-full lg:h-20 font-medium" : "flex justify-between items-center text-base cursor-pointer hover:text-[#2196f3]  text-[#212121]  lg:w-auto w-full lg:h-20 font-medium"} >Dashboard </a>

              <a onClick={() => gotoPage2("student-school")} className={matchPathFn("student-school") ? "flex justify-between items-center text-base cursor-pointer text-[#2196f3] border-b-2 border-[#2196f3] lg:w-auto w-full lg:h-20 font-medium" : "flex justify-between items-center text-base cursor-pointer hover:text-[#2196f3]  text-[#212121]  lg:w-auto w-full lg:h-20 font-medium"}>  School{" "}</a>

              <a onClick={() => gotoPage2("student-assessment-code")} className={matchPathFn("student-assessment-code") ? "flex justify-between items-center text-base cursor-pointer text-[#2196f3] border-b-2 border-[#2196f3] lg:w-auto w-full lg:h-20 font-medium" : "flex justify-between items-center text-base cursor-pointer hover:text-[#2196f3]  text-[#212121]  lg:w-auto w-full lg:h-20 font-medium"}>  Assessment Code{" "}</a>

              <a onClick={() => gotoPage2("student-reports")} className={matchPathFn("student-reports") ? "flex justify-between items-center text-base cursor-pointer text-[#2196f3] border-b-2 border-[#2196f3] lg:w-auto w-full lg:h-20 font-medium" : "flex justify-between items-center text-base cursor-pointer hover:text-[#2196f3]  text-[#212121]  lg:w-auto w-full lg:h-20 font-medium"}>  Reports{" "}</a>

              <a onClick={() => gotoPage2("student-knowledge-hub")} className={matchPathFn("student-knowledge-hub") ? "flex justify-between items-center text-base cursor-pointer text-[#2196f3] border-b-2 border-[#2196f3] lg:w-auto w-full lg:h-20 font-medium" : "flex justify-between items-center text-base cursor-pointer hover:text-[#2196f3]  text-[#212121]  lg:w-auto w-full lg:h-20 font-medium"}>  Knowledge Hub{" "}</a>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-4 md:gap-8">

          <div className="relative flex items-center space-x-2 cursor-pointer group ">
            <div className="flex items-center space-x-2">
              <div className="md:text-lg text-base font-semibold text-[#212121]  h-12  w-12 bg-slate-100 rounded-full flex items-center justify-center uppercase">
                {/* {details && details.name
                  ? details.name.split(' ').map(name => name[0]).join('')
                  : ""} */}
              </div>
              <p className="md:text-base text-sm font-semibold text-[#212121] md:block hidden capitalize ">
                {/* {details && details.name ? details.name : "User"} */} User
              </p>
            </div>
            <span className="cursor-pointer material-icons text-[2rem] md:block hidden">
              arrow_drop_down
            </span>

            <div className="absolute right-0 z-40 hidden w-40 py-2 overflow-hidden bg-white rounded-xl border shadow-xl top-12 md:w-full group-hover:block">

              <button onClick={() => gotoPage2("student-profile")} className="flex items-center w-full px-4 py-2 text-sm font-semibold text-[#212121] cursor-pointer md:text-base hover:bg-slate-100">Jimmy 123</button>

              <button
                // onClick={() => logout()}
                className="flex items-center w-full px-4 py-2 text-sm font-semibold text-red-500 cursor-pointer md:text-base hover:bg-slate-100 "
              >
                <span className="material-symbols-outlined mr-2 text-red-500">
                  logout
                </span>{" "}
                {"Logout"}
              </button>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default withRouter(StudentHeader); // Export with withRouter
